import { styled } from '@/stitches.config';

export const TableHeadStyled = styled('thead', {
  backgroundColor: '$coolGray300',
});
